import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../../../store/LocationDetail";

class TicklerTable extends Component{
  constructor(props) {
    super(props);

    this.state = {
    };
   
    this.sortedTicklers = this.sortedTicklers.bind(this);
  }

    componentDidMount() {
    //if (this.props.zones.length === 0){
      this.props.setTicklers(this.props.match.params.id);
    //}
  }

  sortedTicklers(systems){

    if (systems === null){
      return;
    } 
    
    if (systems.length !== 1 || systems.length !== 0){
      systems.sort(
        (a, b) => (a.inspectionMonth > b.inspectionMonth) ? 1 : -1
      );
    }
    
    // Make a copy so we don't delete anything in the state
    let systemCopy = JSON.parse(JSON.stringify(systems));
    // Because of the way react is, we have to add things to the array
    var displayArray = [];
    
    for (let i=1; i < 13; i++){
      
      displayArray[i] = <div className="tickler-item" key={i+'o'}/>;
      
      for (let j=0; j < systemCopy.length ; j++ ){
        
        if (systemCopy[j] !== undefined){

          if (systemCopy[j].inspectionMonth === i){
            
            displayArray[i] = 
              <div className="tickler-item" key={systemCopy[j].id} style={{cursor:'pointer'}}>
                 <div className="tooltip">
                   <span className="notification-icon-red"/>
                   <div className="tooltip-text alert">
                     {systemCopy[j].serviceType}<br/><br/>
                     Last Inspection Date: {systemCopy[j].lastInspectionDate ? systemCopy[j].lastInspectionDate : 'n/a'}
                   </div>
                 </div>
               </div>
            ;
            systemCopy.shift();
          } 
        }
      }
    }
    return displayArray;
  }

  render(){
    let zones = this.props.zones;
    return(
      <div className="scheduled-flexbox">
        <div className="zones-column">
          <div className="zone-name header"/>
          <div className="zone-content">
            <div className="system-row header">
              <div className="system-name header"/>
              <div className="service-row header">
                <div className="service-name header"/>
                <div className="tickler-row">
                  <div className="tickler-item header">Jan</div>
                  <div className="tickler-item header">Feb</div>
                  <div className="tickler-item header">Mar</div>
                  <div className="tickler-item header">Apr</div>
                  <div className="tickler-item header">May</div>
                  <div className="tickler-item header">Jun</div>
                  <div className="tickler-item header">Jul</div>
                  <div className="tickler-item header">Aug</div>
                  <div className="tickler-item header">Sep</div>
                  <div className="tickler-item header">Oct</div>
                  <div className="tickler-item header">Nov</div>
                  <div className="tickler-item header">Dec</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {Object.keys(zones).map( (key, index) => {
          return(
            <div className="zones-column" key={index}>
              <div className="zone-name">
                <div className="zone-name-text">
                  {key}
                </div>
              </div>
              <div className="zone-content">
                {
                  Object.keys(zones[key]).map((sysKey, i) => {
                    return(
                      <div className={Object.keys(zones[key]).length-1 === i ? "system-row last" : "system-row"} key={i}>
                            <div className="system-name">
                                
                                <div className="tooltip" style={{ cursor: 'pointer' }}>
                                    {sysKey.substr(0, 28)}{sysKey.length > 30 ? '...' : ''}
                                    <div className="tooltip-text alert">
                                        {sysKey}
                                    </div>
                                </div>
                         
                        </div>
                        <div className="system-content">
                          {Object.keys(zones[key][sysKey]).map((servKey, j) => {
                            if (typeof zones[key][sysKey][servKey] === 'object')
                              return (
                                <div className="service-row" key={servKey}>
                                  <div className="service-name" key={servKey}>
                                    <div className="tooltip" style={{cursor:'pointer'}}>
                                      {zones[key][sysKey][servKey]['desc']}
                                      <div className="tooltip-text alert">
                                        {zones[key][sysKey][servKey]['tooltip']}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tickler-row">
                                    {this.sortedTicklers(zones[key][sysKey][servKey]['ticklers'])}
                                  </div>
                                </div>
                              );
                          })}
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          );
        })}
        
      </div>

    );
  };

}

const mapStateToProps = function(state) {
  return {
    user: state.oidc.user,
    zones: state.locationDetail.scheduled,
  }
};

export default withRouter(connect(
  mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(TicklerTable));